<template>
  <custom-button :hover="true" class="login-button">
    <svg-icon icon-class="menu" class-name="link-svg"></svg-icon>
  </custom-button>
</template>

<script>
import customButton from "@/components/customButton";
export default {
  data() {
    return {}
  },
  props: {},
  components: { customButton },
  computed: {},
  mounted() { },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>